import { Component, Input } from '@angular/core'
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms'
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter'
import { DateAdapter, ErrorStateMatcher, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { MatDatepicker } from '@angular/material/datepicker'
import moment, { Moment } from 'moment'

const DATE_FORMAT = 'YYYY-MM-DD'

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'bdg-month-date-field',
  templateUrl: 'date-field-month.component.html',
  styleUrls: ['date-field-month.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class DateFieldMonthComponent implements ErrorStateMatcher {
  @Input()
  control: FormControl

  @Input()
  label: ''

  @Input()
  hint: ''

  @Input()
  readonly: boolean

  date = moment()
  onTouch = (_?: any) => {}

  chosenYearHandler(normalizedYear: moment.Moment) {
    this.date = moment()
    const ctrlValue = this.date
    ctrlValue.year(normalizedYear.year())
    this.date = ctrlValue
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<moment.Moment>) {
    const ctrlValue = this.date
    ctrlValue.month(normalizedMonth.month())
    ctrlValue.date(1)
    this.date = ctrlValue
    this.control.setValue(moment(this.date).format(DATE_FORMAT))
    datepicker.close()
  }

  onDateInput(event: string) {
    const controlValue = this.control.value
    if (controlValue === 'Invalid date' || !controlValue) {
      this.control.setValue('')
    } else {
      const ctrlValue = moment(event, 'MM/YYYY')
      ctrlValue.date(1)
      this.date = ctrlValue
      this.control.setValue(moment(this.date).format(DATE_FORMAT))
    }

    this.control.markAsTouched()
  }

  get matcher() {
    return this as ErrorStateMatcher
  }

  error() {
    return this.control && this.control.touched && this.control.errors?.error
  }

  isErrorState(_: FormControl, form: FormGroupDirective | NgForm): boolean {
    return this.error()
  }
}
